import React from 'react';

var RefundContent = props => {
    return (
      <div className="main refund-page center">
        <h1>Donation Refund Policy</h1>
        <p>Refund requests must be submitted within 7 days of the donation date with an explanation for the request.</p>
      </div>
    )
  };

export default RefundContent;



// WEBPACK FOOTER //
// ./src/components/RefundContent.js